import { useSelector } from "react-redux";
import FilterHeader from "../../components/FilterHeader";
import FilterMarkets from "../../components/FilterMarkets";

const Markets = () => {
  const { ppConfig } = useSelector((state) => state.filter);
  const { marketGroups } = ppConfig;

  if (!marketGroups.length) return null;

  return (
    <>
      <FilterHeader />
      <FilterMarkets marketGroups={marketGroups} />
    </>
  );
};

export default Markets;
